import { inject, Injectable } from '@angular/core';
import { DialogRef, DialogService } from '@ngneat/dialog';
import { MessageDialogComponent } from '../../components/dialogs/message-dialog/message-dialog.component';
import { MessageDialogData } from '../../interfaces/dialog';
import { MediaPlatformService } from '@outlaw/core';
import { MessageDialogPreset, MESSAGE_DIALOG_PRESETS } from '../../constants/message-dialog-presets';

@Injectable({
  providedIn: 'root',
})
export class MessageDialogService {
  #dialogService = inject(DialogService);
  #mediaPlatformService = inject(MediaPlatformService);

  /**
   * Open message dialog with custom data
   */
  open(data: MessageDialogData): DialogRef {
    const maxWidth = this.#mediaPlatformService.isMobile() ? '360px' : '640px';

    return this.#dialogService.open(MessageDialogComponent, {
      maxWidth,
      width: '100%',
      data,
      windowClass: 'community-message-dialog',
    });
  }

  /**
   * Open logout confirmation dialog
   */
  openLogoutConfirm(): DialogRef {
    return this.open(MESSAGE_DIALOG_PRESETS[MessageDialogPreset.LOGOUT]);
  }

  /**
   * Open delete confirmation dialog
   */
  openDeleteConfirm(): DialogRef {
    return this.open(MESSAGE_DIALOG_PRESETS[MessageDialogPreset.DELETE_CONFIRM]);
  }

  /**
   * Open unsaved changes dialog
   */
  openUnsavedChanges(): DialogRef {
    return this.open(MESSAGE_DIALOG_PRESETS[MessageDialogPreset.UNSAVED_CHANGES]);
  }
}
